'use strict';

var React = require('react');

var SvgCornerSquareIcon = function SvgCornerSquareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 5a.25.25 0 0 0-.25.25v10.5a.75.75 0 0 1-1.5 0v-10.5c0-.966.784-1.75 1.75-1.75h10.5a.75.75 0 0 1 0 1.5h-10.5Z"
  }));
};
SvgCornerSquareIcon.displayName = "CornerSquareIcon";

exports.SvgCornerSquareIcon = SvgCornerSquareIcon;
